import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetActionInfoResult } from './IActionInfo';

export interface IGetActionInfoParams {
  // actionId and actionType are mutually exclusive. Only use one.
  actionId?: string;
  actionType?: string;
}

export class GetActionInfoRequest extends Request<IGetActionInfoParams, IGetActionInfoResult> {
  constructor(params: IGetActionInfoParams) {
    super('getActionInfo', params);
  }
}
